import { Component, Injectable, Input, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { ActiveUserSessionService } from 'services/activeusersession.service';
import { AlertService } from 'services/alert.service';
import { AuthenticationService } from 'services/authentication.service';
import { NavigationService } from 'services/navigation.service';
import { UserService } from 'services/user.service';

@Component({
  selector: 'app-add-login',
  templateUrl: './add-login.component.html',
  styleUrls: ['./add-login.component.scss']
})

export class AddLoginComponent implements OnInit {
  @Input() selectedUser: any;

  form: any;
  titleList: any[];
  roleList: any[];
  genderList: any[];
  data: any;
  paramsId: number;
  routeParams: any;
  userData: any;
  isAdd: any;
  routeQueryParams: any;

  constructor(
    private formBuilder: FormBuilder,
    private userService: UserService,
    private navigate: NavigationService,
    private route: ActivatedRoute,
    private alertService: AlertService, private router: Router,
    private dialog: MatDialog,
    private activateroute: ActivatedRoute
  ) {
    debugger
    this.routeQueryParams = this.activateroute.snapshot.queryParams;
    this.userData = this.routeQueryParams;
    this.isAdd = this.userData.isAdd === 'true';
    this.initializeValidators();

  }

  ngOnInit() {
    if (this.userData) {
      this.form.patchValue(this.userData);
      this.paramsId = this.userData.id;
    }

    this.getTitleType(false);
    this.getRoleType(false);
    this.getGenderType(false);


  }
  initializeValidators() {
    this.form = this.formBuilder.group({
      title: ['', [Validators.required]],
      firstName: ['', [Validators.required, Validators.pattern('.*\\S.*[a-zA-z ]')]],
      lastName: ['', [Validators.required, Validators.pattern('.*\\S.*[a-zA-z ]')]],
      identificationNumber: ['', [Validators.required]],
      mobileNumber: ['', [Validators.required, Validators.pattern('^[0-9]+$')]],
      email: ['', [Validators.required, Validators.email]],
      role: ['', [Validators.required]],
    });
  }
  getTitleType(refresh) {
    try {
      this.userService.getTitleType(refresh).subscribe(result => {
        this.titleList = result;
        if (this.userData) {
          const userTitle = Number(this.userData.title);
          const title = this.titleList.find(t =>
            t.key === userTitle
          )
          if (title) {
            this.form.patchValue({
              title: title.key
            });
          }
        }
      });

    } catch (error) {

    }
  }

  getRoleType(refresh) {
    this.userService.getRoleType(refresh).subscribe(result => {

      this.roleList = result;
      this.roleList = result.filter(r => r.value !== 'Customer');

      if (this.userData) {

        const role = this.roleList.find(r =>
          r.value === this.userData.role
        );

        if (role) {
          this.form.patchValue({
            role: role.key
          });
        }
      }
    });
  }
  getGenderType(refresh) {
    try {
      this.userService.getGenderType(refresh).subscribe(
        result => {
          this.genderList = [];
          this.genderList = result;
        }
      )
    }
    catch (error) {

    }
  }
  onCancel() {
    this.navigate.manageUser();
  }
  onSave() {
    if (this.form.valid) {
      this.data = this.form.value

      const payload: any =
      {
        title: this.data.title,
        firstName: this.data.firstName,
        lastName: this.data.lastName,
        identificationNumber: this.data.identificationNumber,
        mobileNumber: this.data.mobileNumber,
        email: this.data.email,
        roleId: this.data.role,
      };

      if (!this.isAdd) {
        payload.userId = this.paramsId;
      }
      this.userService.saveUser(payload).subscribe(
        (result: any) => {
          if (result) {
            if (result == "User created successfully.") {
              this.alertService.success("User created successfully.")
              this.form.reset();
              this.navigate.manageUser();
            }
            else if (result == "User updated successfully.") {
              this.alertService.success("User updated successfully.")
              this.form.reset();
              this.navigate.manageUser();
            }
            else {
              this.alertService.error(result)
            }
          }
          else {
            this.alertService.error("Oops something went wrong")
          }
        }
      )

    }
    else {
      this.alertService.error("Please fill in the mandatory fields")
      return;
    }
  }

  getFormDetails() {
    this.userService.getUserById(this.paramsId).subscribe(
      (res: any) => {
        if (res) {
          this.data = res;
          this.form.patchValue({
            ...res,

          })
        }
      }
    );
  }


}
